import React from "react";
import { motion } from "framer-motion";
import { Lock, Sparkles } from "lucide-react";

const lockPulse = {
    animate: { opacity: [1, 0.6, 1], scale: [1, 1.06, 1] },
    transition: { duration: 2.5, repeat: Infinity, ease: "easeInOut" },
};

export function PlanPreview({ weekOneAction }) {
    return (
        <div
            className="rounded-3xl border border-klareet-bor bg-klareet-card p-6 md:p-8 animate-fade-up"
            data-testid="plan-preview"
        >
            <div className="flex items-center justify-between mb-6">
                <div className="text-[11px] uppercase tracking-[0.2em] text-klareet-MUT font-mono">
                    Your 90-day plan · preview
                </div>
                <div className="inline-flex items-center gap-2 text-klareet-T2 text-xs font-mono">
                    <Sparkles size={14} />
                    Week 1 visible
                </div>
            </div>

            <div className="relative rounded-2xl border border-klareet-T/50 bg-klareet-T/5 p-5 mb-4">
                <div className="text-xs font-mono uppercase tracking-[0.18em] text-klareet-T2 mb-2">
                    Week 1
                </div>
                <p className="text-[15px] md:text-base text-klareet-TEXT leading-relaxed">
                    {weekOneAction}
                </p>
            </div>

            <div className="space-y-3">
                {[
                    { w: "Week 2", preview: "Set three conversations with people one layer deeper than you are today. Write the questions, not the pitch." },
                    { w: "Week 3", preview: "Reframe your resume as a timeline of decisions, not jobs. Identify the one decision you'd undo." },
                    { w: "Week 4", preview: "Run a two-hour experiment: the smallest possible version of the next career you might want." },
                    { w: "Week 5–8", preview: "Pattern-match: compare your last 90 days to the next 90. What repeats, what shouldn't?" },
                    { w: "Week 9–12", preview: "Commit to the move or commit to staying, clearly. Either is progress. Mushy is the problem." },
                ].map(({ w, preview }) => (
                    <div
                        key={w}
                        className="relative rounded-2xl border border-klareet-bor bg-klareet-card/60 p-5"
                    >
                        <div className="select-none" style={{ filter: "blur(4px)" }} aria-hidden>
                            <div className="text-xs font-mono uppercase tracking-[0.18em] text-klareet-MUT mb-2">
                                {w}
                            </div>
                            <p className="text-[15px] text-klareet-TEXT leading-relaxed">
                                {preview}
                            </p>
                        </div>
                        <div className="absolute inset-0 grid place-items-center">
                            <motion.span
                                {...lockPulse}
                                className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-klareet-bor bg-klareet-card text-klareet-MUT text-xs"
                            >
                                <Lock size={12} />
                                Unlocks at launch
                            </motion.span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
